import {
  Box,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  Zoom,
} from "@material-ui/core";
import { Close, ThumbDownAlt, ThumbUpAlt, Update } from "@material-ui/icons";
import * as React from "react";
import { FC, Fragment, useState } from "react";
import {
  Button,
  Datagrid,
  ExportButton,
  FormDataConsumer,
  FunctionField,
  SelectInput,
  TextField,
  TextInput,
  TopToolbar,
  required,
  useNotify,
  useRefresh,
} from "react-admin";
import { DetailButton } from "../../../Components/DetailButton";
import { ConfirmButton } from "../../../Components/ConfirmButton";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../../Constants/Constant";
import { useAppDataProvider } from "../../../dataprovider";
import { TabbedDatagridProps } from "../../../Models/TabbedDataGridProps";
import { Form } from "react-final-form";
import {
  ReliabilityFofReasonChoices,
  ReliabilityFofReasonType,
  ReliabilityFoFRejectReasonType,
  ReliabilityNotFoFReasonType,
} from "../../../../src/Enums/ReliabilityFofReasonType";
import { ReliabilityFoFChoices, ReliabilityFofStatus } from "../.././../../src/Enums/ReliabilityFoFStatus";
import { EnumField } from "../../../../src/Components/EnumField";
import { ReliabilityAfterPoolVendorTypeChoices } from "../../../Enums/ReliabilityAfterPoolVendorType";
import { SourceReliabilityThyFailOnFit } from "./Constants";
import { ReliabilityThyFailOnFitUpdateModel } from "../Models/ReliabilityThyFailOnFitModel";
import { ExcelExport } from "../../../../src/Helper/ExportExcel";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";
import { ReliabilityBeforePoolVendorTypeChoices } from "../../../../src/Enums/ReliabilityBeforePoolVendorType";
import { formatDate } from "../../../../src/Helper/MomentHelper";

const TabbedDatagrid: FC<TabbedDatagridProps> = props => {
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const refresh = useRefresh(); 

  const AcceptFailOnFitButton = props => {
    const acceptButtonClick = record => e => {
      let reliabilityThyFailOnFit: ReliabilityThyFailOnFitUpdateModel = new ReliabilityThyFailOnFitUpdateModel();
      reliabilityThyFailOnFit.Id = record?.id;
      reliabilityThyFailOnFit.Batch = record?.batch;
      reliabilityThyFailOnFit.ReportId = record?.reportId;
      reliabilityThyFailOnFit.BeforeRemovalOrderType = record?.beforeRemovalOrderType;
      reliabilityThyFailOnFit.BeforeRemovalOrderNumber = record?.beforeRemovalOrderNumber;
      reliabilityThyFailOnFit.BeforeRemovalOrderStatus = record?.beforeRemovalOrderStatus;
      reliabilityThyFailOnFit.BeforeRemovalVendorType = record?.beforeRemovalVendorType;
      reliabilityThyFailOnFit.BeforeRemovalVendor = record?.beforeRemovalVendor;
      reliabilityThyFailOnFit.BeforeRemovalCondition = record?.beforeRemovalCondition;
      reliabilityThyFailOnFit.AfterRemovalOrderType = record?.afterRemovalOrderType;
      reliabilityThyFailOnFit.AfterRemovalOrderNumber = record?.afterRemovalOrderNumber;
      reliabilityThyFailOnFit.AfterRemovalOrderStatus = record?.afterRemovalOrderStatus;
      reliabilityThyFailOnFit.AfterRemovalVendorType = record?.afterRemovalVendorType;
      reliabilityThyFailOnFit.AfterRemovalVendor = record?.afterRemovalVendor;
      reliabilityThyFailOnFit.AfterRemovalCondition = record?.afterRemovalCondition;
      reliabilityThyFailOnFit.AcReg = record?.acReg;
      reliabilityThyFailOnFit.AcType = record?.acType;
      reliabilityThyFailOnFit.FleetType = record?.fleetType;
      reliabilityThyFailOnFit.AcRemoveDate = record?.acRemoveDate;
      reliabilityThyFailOnFit.FofStatus = ReliabilityFofStatus.Confirmed;

      dataProvider
        .putReliabilityThyFailOnFit(reliabilityThyFailOnFit)
        .then(result => {
          notify(`Reliability Fail On Fit Updated`, "success", false, true);
          refresh();
        })
        .catch(result => notify(`${result}`, "error", false, true));
    };

    return (
      <ConfirmButton
        {...props}
        variant="text"
        style={{ width: 40, color: "#12824C" }}
        size="medium"
        click={acceptButtonClick(props?.record)}
      >
        <Tooltip TransitionComponent={Zoom} title="Accept Fail On Fit">
          <ThumbUpAlt />
        </Tooltip>
      </ConfirmButton>
    );
  };

  const RejectFailOnFitButton = props => {
    const [open, setOpen] = useState(false);

    const handleClick = e => {
      e.stopPropagation();
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };

    const RejectReliabilityFofButtonClick = props => e => {
      let reliabilityThyFailOnFit: ReliabilityThyFailOnFitUpdateModel = new ReliabilityThyFailOnFitUpdateModel();
      reliabilityThyFailOnFit.Id = props?.record?.id;
      reliabilityThyFailOnFit.Batch = props?.record?.batch;
      reliabilityThyFailOnFit.ReportId = props?.record?.reportId;
      reliabilityThyFailOnFit.BeforeRemovalOrderType = props?.record?.beforeRemovalOrderType;
      reliabilityThyFailOnFit.BeforeRemovalOrderNumber = props?.record?.beforeRemovalOrderNumber;
      reliabilityThyFailOnFit.BeforeRemovalOrderStatus = props?.record?.beforeRemovalOrderStatus;
      reliabilityThyFailOnFit.BeforeRemovalVendorType = props?.record?.beforeRemovalVendorType;
      reliabilityThyFailOnFit.BeforeRemovalVendor = props?.record?.beforeRemovalVendor;
      reliabilityThyFailOnFit.BeforeRemovalCondition = props?.record?.beforeRemovalCondition;
      reliabilityThyFailOnFit.AfterRemovalOrderType = props?.record?.afterRemovalOrderType;
      reliabilityThyFailOnFit.AfterRemovalOrderNumber = props?.record?.afterRemovalOrderNumber;
      reliabilityThyFailOnFit.AfterRemovalOrderStatus = props?.record?.afterRemovalOrderStatus;
      reliabilityThyFailOnFit.AfterRemovalVendorType = props?.record?.afterRemovalVendorType;
      reliabilityThyFailOnFit.AfterRemovalVendor = props?.record?.afterRemovalVendor;
      reliabilityThyFailOnFit.AfterRemovalCondition = props?.record?.afterRemovalCondition;
      reliabilityThyFailOnFit.AcReg = props.record?.acReg;
      reliabilityThyFailOnFit.AcType = props.record?.acType;
      reliabilityThyFailOnFit.FleetType = props.record?.fleetType;
      reliabilityThyFailOnFit.AcRemoveDate = props.record?.acRemoveDate;
      reliabilityThyFailOnFit.Reason = e.reason;
      reliabilityThyFailOnFit.OtherReason = e.otherReason;
      reliabilityThyFailOnFit.FofStatus = ReliabilityFofStatus.Rejected;

      dataProvider
        .putReliabilityThyFailOnFit(reliabilityThyFailOnFit)
        .then(result => {
          notify(`Reliability Fail On Fit Updated`, "success", false, true);
          setOpen(false);
          refresh();
        })
        .catch(result => notify(`${result}`, "error", false, true));
    };

    const ClosePopup = () => {
      setOpen(false);
    };

    return (
      <>
        <IconButton {...props} style={{ width: 40 }} onClick={handleClick}>
          <Tooltip TransitionComponent={Zoom} title="Reject Fail On Fit">
            <ThumbDownAlt />
          </Tooltip>
        </IconButton>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Reject Fail On Fit</DialogTitle>
          <DialogContent>
            <Form
              onSubmit={RejectReliabilityFofButtonClick(props)}
              render={({ handleSubmit }) => (
                <form>
                  <Grid container>
                    <Grid item xs={12}>
                      <SelectInput
                        source="reason"
                        label="Reject Reason"
                        choices={ReliabilityFoFRejectReasonType}
                        optionText="key"
                        optionValue="value"
                        validate={required()}
                        fullWidth
                        variant="outlined"
                      />
                      <FormDataConsumer>
                        {({ formData, ...rest }) =>
                          formData.reason === ReliabilityFofReasonType.Other && (
                            <TextInput
                              source="otherReason"
                              label="Other Reason"
                              fullWidth
                              variant="outlined"
                              multiline
                              {...rest}
                            />
                          )
                        }
                      </FormDataConsumer>
                    </Grid>
                    <Grid item xs={12}>
                      <Button label={"Reject On Fit"} size="large" variant="contained" onClick={handleSubmit}>
                        <Update />
                      </Button>
                      <Button label={"Cancel!"} size="large" variant="contained" onClick={ClosePopup} color="secondary">
                        <Update />
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  };

  const NotFailOnFitButton = props => {
    const [open, setOpen] = useState(false);

    const handleClick = e => {
      e.stopPropagation();
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };

    const ReliabilityNotFofButtonClick = props => e => {
      let reliabilityThyFailOnFit: ReliabilityThyFailOnFitUpdateModel = new ReliabilityThyFailOnFitUpdateModel();
      reliabilityThyFailOnFit.Id = props?.record?.id;
      reliabilityThyFailOnFit.Batch = props?.record?.batch;
      reliabilityThyFailOnFit.ReportId = props?.record?.reportId;
      reliabilityThyFailOnFit.BeforeRemovalOrderType = props?.record?.beforeRemovalOrderType;
      reliabilityThyFailOnFit.BeforeRemovalOrderNumber = props?.record?.beforeRemovalOrderNumber;
      reliabilityThyFailOnFit.BeforeRemovalOrderStatus = props?.record?.beforeRemovalOrderStatus;
      reliabilityThyFailOnFit.BeforeRemovalVendorType = props?.record?.beforeRemovalVendorType;
      reliabilityThyFailOnFit.BeforeRemovalVendor = props?.record?.beforeRemovalVendor;
      reliabilityThyFailOnFit.BeforeRemovalCondition = props?.record?.beforeRemovalCondition;
      reliabilityThyFailOnFit.AfterRemovalOrderType = props?.record?.afterRemovalOrderType;
      reliabilityThyFailOnFit.AfterRemovalOrderNumber = props?.record?.afterRemovalOrderNumber;
      reliabilityThyFailOnFit.AfterRemovalOrderStatus = props?.record?.afterRemovalOrderStatus;
      reliabilityThyFailOnFit.AfterRemovalVendorType = props?.record?.afterRemovalVendorType;
      reliabilityThyFailOnFit.AfterRemovalVendor = props?.record?.afterRemovalVendor;
      reliabilityThyFailOnFit.AfterRemovalCondition = props?.record?.afterRemovalCondition;
      reliabilityThyFailOnFit.AcReg = props.record?.acReg;
      reliabilityThyFailOnFit.AcType = props.record?.acType;
      reliabilityThyFailOnFit.FleetType = props.record?.fleetType;
      reliabilityThyFailOnFit.AcRemoveDate = props.record?.acRemoveDate;
      reliabilityThyFailOnFit.Reason = e.reason;
      reliabilityThyFailOnFit.OtherReason = e.otherReason;
      reliabilityThyFailOnFit.FofStatus = ReliabilityFofStatus.NotFof;

      dataProvider
        .putReliabilityThyFailOnFit(reliabilityThyFailOnFit)
        .then(result => {
          notify(`Reliability Fail On Fit Updated`, "success", false, true);
          refresh();
        })
        .catch(result => notify(`${result}`, "error", false, true));
    };

    const ClosePopup = () => {
      setOpen(false);
    };

    return (
      <>
        <IconButton {...props} style={{ width: 40, color: "red" }} onClick={handleClick}>
          <Tooltip TransitionComponent={Zoom} title="Not Fail On Fit">
            <Close />
          </Tooltip>
        </IconButton>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Not Fail On Fit</DialogTitle>
          <DialogContent>
            <Form
              onSubmit={ReliabilityNotFofButtonClick(props)}
              render={({ handleSubmit }) => (
                <form>
                  <Grid container>
                    <Grid item xs={12}>
                      <SelectInput
                        source="reason"
                        label="Not Fof Reason"
                        choices={ReliabilityNotFoFReasonType}
                        optionText="key"
                        optionValue="value"
                        validate={required()}
                        fullWidth
                        variant="outlined"
                      />

                      <FormDataConsumer>
                        {({ formData, ...rest }) =>
                          formData.reason === ReliabilityFofReasonType.Other && (
                            <TextInput
                              source="otherReason"
                              label="Other Reason"
                              fullWidth
                              variant="outlined"
                              multiline
                              {...rest}
                            />
                          )
                        }
                      </FormDataConsumer>
                    </Grid>
                    <Grid item xs={12}>
                      <Button label={"Not Fail On Fit"} size="large" variant="contained" onClick={handleSubmit}>
                        <Update />
                      </Button>
                      <Button label={"Cancel!"} size="large" variant="contained" onClick={ClosePopup} color="secondary">
                        <Update />
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  };

  const DetailsButton = ({ record }) => {
    return <DetailButton record={record} resource={SourceReliabilityThyFailOnFit} />;
  };

  const OptButtonGroup = ({ record }) => {
    return (
      <Box style={{ flex: 1, flexDirection: "row" }}>
        <ButtonGroup variant="text" size="small">
          <DetailsButton record={record} />
          <>
            <AcceptFailOnFitButton record={record} />
            <RejectFailOnFitButton record={record} />
            <NotFailOnFitButton record={record} />
          </>
        </ButtonGroup>
      </Box>
    );
  };

  return (
    <Fragment>
      <Datagrid optimized basePath={SourceReliabilityThyFailOnFit}>
        <OptButtonGroup record={props} />
        <TextField source="batch" label="Batch" />
        <TextField source="goodsRcvdBatch" label="Goods Received Batch" />
        <TextField source="acReg" label="Ac Reg" />
        <TextField source="pn" label="Pn" />
        <TextField source="sn" label="Sn" />
        <TextField source="pnDescription" label="Pn Description" />
        <FunctionField
          label="Created Date"
          sortBy="createdDate"
          render={(record: any) => {
            return record.createdDate === null ? null : formatDate(record.createdDate);
          }}
        />

        <TextField source="beforeRemovalVendorType" label="Before Removal Vendor Type" />
        <TextField source="afterRemovalVendorType" label="After Removal Vendor Type" />
        <EnumField label={"Fof Status"} enumName={"ReliabilityFofStatus"} source={"fofStatus"} />
        <EnumField label={"Reason"} enumName={"ReliabilityFofReasonType"} source={"reason"} />
      </Datagrid>
    </Fragment>
  );
};

const ThyFailOnFitList = props => {
  const ListActions = props => {
    return (
      <TopToolbar {...props}>
        <ExportButton
          resource={props.resource}
          sort={props.currentSort}
          filterValues={props.filterValues}
          maxResults={10000}
        />
      </TopToolbar>
    );
  };

  const exporter = records => {
    const data = records.map(record => {
      const mappedRecord = {
        //...record,
        Batch: record.batch,
        "Goods Received Batch": record.goodsRcvdBatch,
        "Ac Reg": record.acReg,
        "Ac Remove Date": record.acRemoveDate,
        Pn: record.pn,
        Sn: record.sn,
        Chapter: record.chapter,
        "Pn Description": record.pnDescription,
        "Fof Status": ReliabilityFoFChoices.find(x => x.value === record.fofStatus)?.key,
        Reason: ReliabilityFofReasonChoices.find(x => x.value === record.reason)?.key,
        "After Removal Order Type": record.afterRemovalOrderType,
        "After Removal Order Number": record.afterRemovalOrderNumber,
        "After Removal Order Status": record.afterRemovalOrderStatus,
        "After Removal Vendor Type": record.afterRemovalVendorType,
        "After Removal Vendor": record.afterRemovalVendor,
        "After Removal Condition": record.afterRemovalCondition,
        "Before Removal Order Type": record.beforeRemovalOrderType,
        "Before Removal Order Number": record.beforeRemovalOrderNumber,
        "Before Removal Order Status": record.beforeRemovalOrderStatus,
        "Before Removal Vendor Type": record.beforeRemovalVendorType,
        "Before Removal Vendor": record.beforeRemovalVendor,
        "Before Removal Condition": record.beforeRemovalCondition,
        "Sub Category": record.subCategory,
        "Reliability Report Created Date": record.reliabilityReportCreatedDate,
      };
      return mappedRecord;
    });

    const columns = Object.keys(data[0]).map(record => ({ header: record }));

    ExcelExport(columns, data, "THY Fail on Fit List");
  };

  const fofChoices = [{ key: "ALL" }, ...ReliabilityFoFChoices];

  const filters = [
    <TextInput label="Batch" source="batch__eq" alwaysOn />,
    <TextInput label="Ac Reg" source="acReg__contains" alwaysOn />,
    <TextInput label="Pn" source="pn__contains" alwaysOn />,
    <TextInput label="Sn" source="sn__contains" alwaysOn />,
    <TextInput label="Pn Description" source="pnDescription__contains" alwaysOn />,
    <SelectInput
      label="Before Removal Vendor Type"
      source="beforeRemovalVendorType__eq"
      choices={ReliabilityBeforePoolVendorTypeChoices}
      optionValue="key"
      optionText="key"
      allowEmpty
      emptyText="ALL"
      alwaysOn
    />,
    <SelectInput
      label="After Removal Vendor Type"
      source="afterRemovalVendorType__eq"
      choices={ReliabilityAfterPoolVendorTypeChoices}
      optionValue="key"
      optionText="key"
      allowEmpty
      emptyText="ALL"
      alwaysOn
    />,
    <SelectInput
      label="FoF Status"
      source="fofStatus__eq"
      choices={fofChoices}
      optionValue="value"
      optionText="key"
      alwaysOn
    />,
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <PoolList
          {...props}
          hasCreate={false}
          exporter={exporter}
          actions={<ListActions />}
          bulkActionButtons={false}
          resource={SourceReliabilityThyFailOnFit}
          title={"THY Fail On Fit List"}
          sort={DefaultCreatedDateSort}
          perPage={DefaultPerPageSize}
          filters={filters}
          filter={props?.filterParams}
        >
          <TabbedDatagrid />
        </PoolList>
      </Grid>
    </Grid>
  );
};

export default ThyFailOnFitList;
